import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import I18n from 'utils/I18n';
import Cldr from 'utils/Cldr';

import { getTrialProduct } from '../../../actions';

import styles from './index.scss';
import PromoButton from './PromoButton';

export const I18nPrefix = 'strava.subscriptions.checkout.summary.organic';

export const Footer = ({
  cartData,
  isPromoCodeInputVisable,
  isTrial,
  isTrialEligible,
  promotionApplied,
  onToggleShowPromoCodeInput,
  handleRemovePromoCode,
  handleGetTrialProduct
}) => {
  return (
    <div className={styles.summaryFooter}>
      <div className={styles.billedToday}>
        <div className={styles.billed}>
          <strong>{I18n.t(`${I18nPrefix}.billed_today`)}</strong>
        </div>
        <div className={styles.billedTotal}>
          <strong>
            {Cldr.formatCurrency(cartData.billedToday, cartData.currency)}
          </strong>
        </div>
      </div>
      <div className={styles.footerActions}>
        {!isTrial && (
          <>
            <PromoButton
              promotionApplied={promotionApplied}
              isPromoCodeInputVisable={isPromoCodeInputVisable}
              onToggleShowPromoCodeInput={onToggleShowPromoCodeInput}
              handleRemovePromoCode={handleRemovePromoCode}
            />
          </>
        )}
        {isTrialEligible && (
          <>
            <button
              className={`btn btn-link ${styles.actionButton}`}
              onClick={handleGetTrialProduct}
              type="button"
            >
              {I18n.t(`${I18nPrefix}.cta.redeem_trial_offer`)}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

Footer.propTypes = {
  promotionApplied: PropTypes.bool.isRequired,
  // TODO: udpate this to use shared cartData after refactor
  cartData: PropTypes.shape({
    billedToday: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired
  }).isRequired,
  isPromoCodeInputVisable: PropTypes.bool.isRequired,
  isTrial: PropTypes.bool.isRequired,
  isTrialEligible: PropTypes.bool.isRequired,
  onToggleShowPromoCodeInput: PropTypes.func.isRequired,
  handleRemovePromoCode: PropTypes.func.isRequired,
  handleGetTrialProduct: PropTypes.func.isRequired
};

export default connect(
  undefined,
  { handleGetTrialProduct: getTrialProduct }
)(Footer);
